import styles from './Product.module.css'
import icon from './assets/icon.svg';
import star from './assets/star.svg';
import standard from './assets/standard.svg';
import { ProductBasedRules } from "../../Helpers/ProductBasedRules";

import { generateThumbnail } from '../../Helpers/ThumbHelper';



export default function Product({id,product,tierColumn,specifier,warranty,focus,size,title,description,onSelect,isActive,tier, series}) {

    const { filterProduct, getTierString } = ProductBasedRules();

    let tierString = tierColumn ? product[tierColumn] : '';
    tierString = tierString.indexOf(',') ? tierString.split(',')[0] : tierString;
    //some plans require hijacking of tier string
    tierString = getTierString(tierString,product);
    const layouts = () => {
        switch (series) {
            case 8492: // Baseboards
            case 8498: // Cabinet Crowns
            case 8499: // Exterior Doors
            case 8531: // Appliances
            case 8533: // Kitchen Cabinet Hardware
            case 8529: // Bathroom Cabinet Hardware
                return (
                    <>
                        <div className={styles.title}>{title}</div>
                    </>
                );
        
            case 8548: // Exterior Lighting
                return (
                    <>
                        <div className={styles.title}>{title}</div>
                        <div className={styles.description}>{product.color}</div>
                        <div className={styles.description}>{product.description}</div>
                    </>
                );
        
            case 8496: // Bathroom & Kitchen Cabinets
                return (
                    <>
                        <div className={styles.title}>{product.name}</div>
                        <small>{product.color}</small>
                    </>
                );
        
            case 8495: // Countertops
            case 8487: // Roof Layout
                return (
                    <>
                        <div className={styles.title}>{description}</div>
                        <div className={styles.description}>{title}</div>
                    </>
                );
            case 8532: // Kitchen Faucet Layout
            return (
                <>
                    <div className={styles.title}>{product.name}</div>
                    <div className={styles.description}>{product.description}</div>
                </>
            );
        
            default:
                return (
                    <>
                        <div className={styles.title}>{title}</div>
                        <div className={styles.description}>{description}</div>
                    </>
                );
        }
        
    };

    return(
            <li className={`${styles.product} ${isActive?styles.active:''}`}  data-id={id} onClick={() => {onSelect(id)}} >
                <div className={styles.imgWrapper}>
                    <img loading='lazy' src={generateThumbnail(product,size,focus)} alt={`Product - ${id}`} />
                    <div className={styles.activeContent}>
                        <img src={icon} className={styles.selectedImg} width="96" height="69" alt="product thumbnail"/>
                    </div>
                </div>
                {(series !== 8549 && series !== 8530) && (<div className={styles.productInfo}>
                    {/* <p> CODE - {product.style}</p> */}
                {product.id === -1 ? (
                        <>
                            <p className='tier'><img src={standard} width="10" height="10" alt="standard" /> Standard</p>
                            <div className={styles.title}>{product.name}</div>
                        </>
                    ) : (
                        <>
                            {layouts()}
                            {tier == "Standard" && (
                                <p className='tier'>
                                    <img src={standard} width="10" height="10" alt="standard" /> Standard
                                </p>
                            )}
                            {tier == "Upgrade" && (
                                <p className='tier'>
                                    <img src={star} width="10" height="10" alt="upgrade" /> Upgrade
                                </p>
                            )}
                        </>
                    )}
                </div>)}

                {(series === 8549 || series === 8530) && (<div className={styles.productInfo}>
                        <>
                            <div className={styles.title}>{product.name}</div>
                        </>
                </div>)}
            </li>
    );
}